// extracted by mini-css-extract-plugin
module.exports = {"open":"Modal_open__rokI9","fadeIn":"Modal_fadeIn__6I3Qq","close":"Modal_close__x4nmI","fadeOut":"Modal_fadeOut__iCvff"};